import { createBrowserClient } from '@supabase/ssr';

export function createClient() {
  // Safety check for browser environment - check both window and document
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    // Return a minimal client for SSR that won't crash
    return createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
      {
        cookies: {
          getAll() {
            return [];
          },
          setAll() {
            // No-op on server
          },
        },
      }
    );
  }

  // Browser environment - both window and document are available
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      cookies: {
        getAll() {
          // Additional safety check before accessing document.cookie
          if (typeof document === 'undefined' || !document.cookie) {
            return [];
          }
          return document.cookie.split(';').map((cookie) => {
            const [name, ...rest] = cookie.trim().split('=');
            return { name, value: decodeURIComponent(rest.join('=')) };
          });
        },
        setAll(cookiesToSet: Array<{ name: string; value: string; options?: any }>) {
          // Additional safety check before accessing document.cookie
          if (typeof document === 'undefined') {
            return;
          }

          cookiesToSet.forEach(({ name, value, options }) => {
            // Use SameSite=Lax for localhost (HTTP), SameSite=None only for HTTPS
            const sameSite = window.location.protocol === 'https:' ? 'None' : 'Lax';
            const secureFlag = window.location.protocol === 'https:' ? '; Secure' : '';

            let cookieString = `${name}=${encodeURIComponent(value)}; Path=${options?.path || '/'}${secureFlag}; SameSite=${sameSite}`;

            if (options?.maxAge) {
              cookieString += `; max-age=${options.maxAge}`;
            }
            if (options?.domain) {
              cookieString += `; domain=${options.domain}`;
            }
            if (options?.expires) {
              cookieString += `; expires=${options.expires}`;
            }

            document.cookie = cookieString;
          });
        },
      },
    }
  );
}
